import React from 'react';
import Form from 'src/components/form/Form';
import guestService from 'src/services/api/guest';
import { RegistrationSection, RegistrationForm } from 'src/assets/styles/components/Registration';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import Swal from 'sweetalert2';

const Registration = (props) => {
  const [Attendant, set_Attendant] = React.useState({});
  const [loadedData, set_loadedData] = React.useState(false);
  const getCaptchaToken = useRecaptchaToken('guest_create');

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_Attendant({ ...Attendant, [name]: value });
  };

  const handleDropDown = ({ name, value }) => {
    set_Attendant({ ...Attendant, [name]: value });
  };

  async function createAttendant(e) {
    e.preventDefault();

    const { name, lastName, phone, identification, email } = Attendant;

    if (!name || !lastName || !phone || !identification) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Todos los campos son obligatorios.',
      });
      return;
    }

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      Swal.fire({
        icon: 'error',
        title: 'Error de seguridad',
        text: RECAPTCHA_SECURITY_ERROR,
      });
      return;
    }

    set_loadedData(true);
    guestService
      .createGuest({
        name,
        lastName,
        phone,
        identification,
        email,
        ...(captchaRequired ? { captcha } : {}),
      })
      .then((response) => {
        const { success, created, guest, message } = response.data || {};

        if (success && created && guest?.identification) {
          set_Attendant({});
          set_loadedData(false);
          Swal.fire({
            icon: 'success',
            text: message || 'El participante se creó correctamente.',
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            props.history.push(`/checkin/crecer?id=${guest.identification}`);
          });
          return;
        }

        Swal.fire({
          icon: success ? 'info' : 'warning',
          text: message || 'Verifica los datos e intenta de nuevo.',
        });
        set_loadedData(false);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text:
            error.response?.data?.message || 'Error al crear el participante. Intenta de nuevo.',
        });
        set_loadedData(false);
      });
  }

  return (
    <RegistrationSection>
      <h1 className="Registration__title">Registro</h1>
      <RegistrationForm>
        <Form
          saveTag={'Crear participante '}
          Attendant={Attendant}
          userprofile={true}
          handleInputs={handleInputs}
          handleDropDown={handleDropDown}
          errorInputs={{}}
          sendInForm
          loadedData={loadedData}
          submit={createAttendant}
          allowInlineGuestEdit
        />
      </RegistrationForm>
    </RegistrationSection>
  );
};
export default Registration;
